export default "__VITE_ASSET__FrF27gO0__"